import React from 'react';
import History from 'mdi-material-ui/History';

import { ClearFormBoxProps } from './ClearFormBox.interface';
import { useStyles } from './ClearFormBox.styles';
import { ClearFormMessageBox } from 'app/components/ClearFormMessageBox';
import { LabelEnum } from 'app/shared/enums';

function ClearFormBox({ clearFunction }: ClearFormBoxProps) {
  const classes = useStyles();

  return (
    <ClearFormMessageBox
      className={classes.root}
      clearFunction={clearFunction}
      icon={History}
      subTitle={LabelEnum.WeFoundYourLastComparison}
      title={LabelEnum.ItSGoodThatYouReComingBackToUs}
    />
  );
}

export default ClearFormBox;
